// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2r3RU","fullView":"styles_fullView__1AMvN"};